/*
 * The logic behind textbox drawing.
 */

import translator from './../utils/translation'
import { removeUnwantedText } from './customUtil'

const textBoxDrawing = (fabricCanvas, fabric, setActiveTool) => {
    let isDrawingText = false
    let isTextActive = false
    let textbox
    let textboxRect
    let origX
    let origY
    let pointer

    fabricCanvas.on('mouse:down', (o) => {
        if (!fabricCanvas.isDrawingTextMode || !fabric.CustomTextbox) return

        if (isTextActive && textbox.text !== 'Your text goes here...') {
            setActiveTool('select')
            isTextActive = false
            return
        }
        if (fabricCanvas.getActiveObject()?.get('type') === 'CustomTextbox') {
            setActiveTool('select')
            isTextActive = false
            return
        }

        isDrawingText = true
        pointer = fabricCanvas.getPointer(o.e)
        origX = pointer.x
        origY = pointer.y
        textboxRect = new fabric.Rect({
            left: origX,
            top: origY,
            width: pointer.x - origX,
            height: pointer.y - origY,
            strokeWidth: 1,
            transparentCorners: false,
            fill: 'rgba(255,255,255,0)',
            stroke: '#DADADA'
        })
        fabricCanvas.add(textboxRect)
        fabricCanvas.bringToFront(textboxRect)
        isTextActive = true
    })

    fabricCanvas.on('mouse:move', (o) => {
        if (!isDrawingText) return

        pointer = fabricCanvas.getPointer(o.e)

        if (origX > pointer.x) {
            textboxRect.set({ left: Math.abs(pointer.x) })
        }

        if (origY > pointer.y) {
            textboxRect.set({ top: Math.abs(pointer.y) })
        }

        textboxRect.set({ width: Math.abs(origX - pointer.x) })
        textboxRect.set({ height: Math.abs(origY - pointer.y) })
        fabricCanvas.bringToFront(textboxRect)
        fabricCanvas.requestRenderAll()
        fabricCanvas.calcOffset()
    })

    fabricCanvas.on('mouse:up', () => {
        if (!isDrawingText) return

        removeUnwantedText(fabricCanvas)
        isDrawingText = false
        // get final rect coords and replace it with textbox
        textbox = new fabric.CustomTextbox(
            translator('Your text goes here...'),
            {
                left: textboxRect.left,
                top: textboxRect.top,
                width: textboxRect.width < 80 ? 200 : textboxRect.width,
                fontSize: textConfiguration.fontSize,
                //  fontSize: 20,
                fontWeight: textConfiguration.fontWeight,
                fill: '#000000',
                fontStyle: textConfiguration.fontStyle,
                underline: textConfiguration.underline,
                fontFamily: "'Open Sans', sans-serif",
                padding: 5,
                strokeDashArray: [],
                strokeLineCap: 'butt'
            }
        )
        // console.log('textbox:', textbox)
        fabricCanvas.remove(textboxRect)
        fabricCanvas.add(textbox).setActiveObject(textbox)
        textbox.enterEditing().selectAll()
        textbox.setControlsVisibility({ mb: false })
        fabricCanvas.bringToFront(textbox)
        fabricCanvas.fire('object:modified')
    })
}

export default textBoxDrawing
